import { render, staticRenderFns } from "./SHProposalPolicyholder.vue?vue&type=template&id=024fda48"
import script from "./SHProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./SHProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports